import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DmsChangeFormComponent } from './dms-change-form/dms-change-form.component';
import { LandingPageRequestComponent } from './landing-page-request/landing-page-request.component';
import { TechRequestComponent } from './tech-request/tech-request.component';
import { CreateTaskExternalModal } from './create-task-external/create-task-external.component';
import { StrategyReviewFormComponent } from './strategy-review-form/strategy-review-form.component';
import { CreativeRequestComponent } from './creative-request/creative-request.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    DmsChangeFormComponent,
    LandingPageRequestComponent,
    TechRequestComponent,
    CreateTaskExternalModal,
    StrategyReviewFormComponent,
    CreativeRequestComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    DragDropModule,
    TranslateModule
  ],
  exports: [DmsChangeFormComponent, TechRequestComponent]
})
export class FormsModuleCustom {}
